module.exports = "<textarea class=\"lpview_form_textarea form_textarea {{cssClass}}\" name=\"{{name}}\" cols=\"{{cols}}\" rows=\"{{rows}}\"></textarea>";